/**
 * What an object list shows before anybody touches a filter.
 *
 * SHARED ON PURPOSE. The Objects list and the record rail on the detail page each decide what to
 * show, and when they decided separately they disagreed -- t5 shipped a rail listing 19 rules beside
 * a list showing 24, because one fell back to "no filter" and the other to its own default. One
 * constant, imported by both, is what makes that impossible rather than merely unlikely.
 *
 * Draft and Released: what somebody is working on and what is in force. Superseded, Cancelled and
 * Void are history, and a list that opens on history is a list nobody asked for.
 */
export const DEFAULT_STATUSES = ["DRAFT", "RELEASED"];

/** One entry per status a list can filter on: the display label and the value stored on the
 *  revision. Ordered as the sidebar shows them: live states first, terminal ones after. */
export type StatusEntry = {label: string; status: string};

// THE REVISION LIFECYCLE, which every species but one moves through.
export const LIFECYCLE_STATUSES: StatusEntry[] = [
    {label: "Draft", status: "DRAFT"},
    {label: "Released", status: "RELEASED"},
    {label: "Deprecated", status: "DEPRECATED"},
    {label: "Superseded", status: "SUPERSEDED"},
    {label: "Cancelled", status: "CANCELLED"},
    {label: "Void", status: "VOID"},
];

// A PROJECT IS OPEN OR CLOSED. Ed, 2026-10-27: "Project is just Open or Closed, no lifecycle other
// than that." The server stores exactly those two words on a Project revision, so a sidebar that
// offered Draft and Released over the Projects list offered six filters that could never match --
// and ticking Draft and Released by default, as every other list does, made the Projects list open
// on ZERO rows while PRJ-00001 sat OPEN one query away. That is the fault this vocabulary closes.
export const PROJECT_STATUSES: StatusEntry[] = [
    {label: "Open", status: "OPEN"},
    {label: "Closed", status: "CLOSED"},
];

/** The statuses a list of this classification can filter on. */
export function statusVocabularyFor(classification: string): StatusEntry[] {
    return classification === "Project" ? PROJECT_STATUSES : LIFECYCLE_STATUSES;
}

/** What a list of this classification ticks before anybody touches a filter: the records somebody
 *  is working on or working from. For a project that is the open ones. */
export function defaultStatusesFor(classification: string): string[] {
    return classification === "Project" ? ["OPEN"] : DEFAULT_STATUSES;
}
